import {
  CREATE_DATA,
  PAGINATION_DEFAULT_LIMIT,
} from "../../utilities/constants";
import { paginationData } from "../../utilities/functions";
import { fetchApi } from "../fetchApi";

const getDomain = (
  { query, type },
  company_id,
  context,
  company_partner_id
) => {
  // ['|', ('company_id', '=', company_id), ('id', '=', company_id)]
  // console.log("context", context);
  let domain = [
    "|",
    ["company_id", "=", company_id],
    ["id", "=", company_partner_id],
  ];
  if (query || type) {
    if (type) {
      domain = ["&", ...domain];
    }
    if (query) {
      domain = ["&", ...domain, "|", "|"];
    }
  }

  if (query) {
    domain = [
      ...domain,
      ["display_name", "ilike", query],
      ["ref", "=", query],
      ["email", "ilike", query],
    ];
  }
  if (type) {
    const typeValue = JSON.parse(type);
    domain = [...domain, ...typeValue];
  }

  return domain;
};

export async function searchReadContacts({
  context,
  company_id,
  pagination = { limit: PAGINATION_DEFAULT_LIMIT, offset: 0 },
  search = { query: "", type: "" },
  sort = { type: "", dir: "asc" },
  company_partner_id,
}) {
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      model: "res.partner",
      domain: getDomain(search, company_id, context, company_partner_id),
      fields: [
        "image_1920",
        "id",
        "color",
        "display_name",
        "title",
        "email",
        "parent_id",
        "is_company",
        "function",
        "phone",
        "street",
        "street2",
        "zip",
        "city",
        "country_id",
        "mobile",
        "sale_order_count",
        "opportunity_count",
        "meeting_count",
        "state_id",
        "category_id",
        "image_128",
        "type",
        "activity_state",
        "activity_ids",
        "activity_exception_decoration",
        "activity_exception_icon",
      ],
      ...paginationData(pagination),
      sort: sort?.type ? `${sort?.type} ${sort?.dir}` : "",
      context: {
        lang: context.lang,
        tz: context.tz,
        uid: context.uid,
        allowed_company_ids: [company_id],
        default_type: "opportunity",
        search_default_assigned_to_me: 1,
        bin_size: true,
      },
    },
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };
  return fetchApi({ requestOptions, endpoint: "/web/dataset/search_read" });
}
